module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/51e8be843e2f2041731435f81bae1dd4.png";